import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const StyledInput = styled('input', {
  shouldForwardProp: (prop) => prop !== 'isDarkMode'
})(({ isDarkMode }) => ({
  width: "100%",
  padding: "14px 16px",
  fontSize: "15px",
  border: `2px solid ${isDarkMode ? "#4a5568" : "#e5e7eb"}`,
  borderRadius: "10px",
  boxSizing: "border-box",
  outline: "none",
  transition: "all 0.2s ease",
  fontFamily: "inherit",
  backgroundColor: isDarkMode ? "#2d2d3f" : "#fafafa",
  color: isDarkMode ? "#e2e8f0" : "inherit",
  '&:focus': {
    borderColor: "#219297",
    backgroundColor: isDarkMode ? "#3d3d4f" : "#ffffff",
    boxShadow: "0 0 0 3px rgba(33, 146, 151, 0.1)",
  }
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isDarkMode'
})(({ isDarkMode, disabled }) => ({
  py: 1.75,
  backgroundColor: disabled ? (isDarkMode ? "#2d2d3f" : "#cbd5e1") : "#219297",
  color: disabled ? (isDarkMode ? "#a0aec0" : undefined) : "#ffffff",
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "15px",
  textTransform: "none",
  boxShadow: disabled ? "none" : "0 4px 12px rgba(33, 146, 151, 0.3)",
  transition: "all 0.2s ease",
  '&:hover': {
    backgroundColor: disabled ? (isDarkMode ? "#2d2d3f" : "#cbd5e1") : "#1a7a7d",
    boxShadow: disabled ? "none" : "0 6px 16px rgba(33, 146, 151, 0.4)",
    transform: disabled ? "none" : "translateY(-1px)",
  },
  '&:active': {
    transform: disabled ? "none" : "translateY(0)",
  }
}));